export default "__VITE_ASSET__40a0bfce__"